module.exports = __webpack_public_path__ + "img/national-cancer-institute-L7en7Lb-Ovc-unsplash.87be3135.jpg";